/**
 * Registry of active StudyGroupDoc instances, keyed by groupId.
 *
 * `useStudyGroupDoSync` registers its per-group `StudyGroupDoc` here
 * on mount and unregisters on unmount. Non-React callers that need to
 * reach into the group's Y.Doc (e.g. serialising a shared deck's
 * notes into a push payload, or reading them from a scoped-deck
 * snapshot helper) use `getActiveStudyGroupDoc(groupId)` instead of
 * threading the doc through props.
 *
 * Mirrors `src/sync/yjs/active-deck-docs.ts` which does the same job
 * for the per-user `UserNotesDoc`.
 */

import type { StudyGroupDoc } from '../../yjs/study-group-doc';

const active = new Map<string, StudyGroupDoc>();

export function registerStudyGroupDoc(groupId: string, doc: StudyGroupDoc): () => void {
  active.set(groupId, doc);
  return () => {
    if (active.get(groupId) === doc) active.delete(groupId);
  };
}

export function unregisterStudyGroupDoc(groupId: string): void {
  active.delete(groupId);
}

export function getActiveStudyGroupDoc(groupId: string): StudyGroupDoc | undefined {
  return active.get(groupId);
}
